/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-06-24 10:59:11
 * @LastEditors: changfeng
 * @LastEditTime: 2024-07-25 18:18:24
 */
export default (initialState: any) => {
  // 在这里按照初始化数据定义项目中的权限，统一管理
  // 参考文档 https://umijs.org/docs/max/access

  const currentUser = initialState?.currentUser;

  return {
    Admin: currentUser && currentUser.roleName === 'admin',
    canSeeUserManagement: currentUser && currentUser.roleName === 'admin',
    canSeeDepartmentManagement: currentUser && currentUser.roleName === 'admin',
    canSeeShopManagement: currentUser && currentUser.roleName === 'admin',
    canSeeSKUManagement:
      currentUser &&
      (currentUser.roleName === 'admin' || currentUser.roleName !== 'factory'),
    canSeeQuality:
      currentUser &&
      (currentUser.roleName === 'admin' || currentUser.roleName === 'supplier'),
    canSeeOrder:
      currentUser &&
      (currentUser.roleName === 'admin' || currentUser.roleName !== 'factory'),
    canSeeFinance:
      currentUser &&
      (currentUser.roleName === 'admin' || currentUser.roleName !== 'factory'),
    canSeeFactory:
      currentUser &&
      (currentUser.roleName === 'admin' ||
        currentUser.roleName === 'supplier' ||
        currentUser.roleName === 'factory'),
    canSeeFactoryFinance:
      currentUser &&
      (currentUser.roleName === 'admin' || currentUser.roleName === 'supplier'),
    canSeeDictionaryManagement:
      currentUser &&
      (currentUser.roleName === 'admin' || currentUser.roleName === 'supplier'),
  };
};
